import { EmailOutlined, MessageTooltip, Spacer } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import "../../../../i18n/i18n";

export interface SharedInterfaceMonthlyReportsProps {
  canGenerateReports: boolean;
}

export const SharedInterfaceMonthlyReports = (
  props: SharedInterfaceMonthlyReportsProps,
) => {
  const { t } = useTranslation();

  return (
    <>
      {props.canGenerateReports && (
        <MessageTooltip
          type="NEUTRAL"
          iconLeft={<EmailOutlined />}
          title={t("fleet.monthlyReports.recipientsBanner.title")}
          text={
            <>
              {t("fleet.monthlyReports.recipientsBanner.bodyBeforeLink")}
              <StyledLink href="/home/users/management">
                {t("fleet.monthlyReports.recipientsBanner.link")}
              </StyledLink>
              {t("fleet.monthlyReports.recipientsBanner.bodyAfterLink")}
            </>
          }
        />
      )}
      <Spacer y={1.5} />
    </>
  );
};

const StyledLink = styled.a`
  text-decoration: underline;
  color: inherit;
`;
